const theme = {
  colors: {
    mainColor: "#0085FF",
    fontBorder: "#032D99",
    fontColor: "#505050",
    white: "#ffffff",
    timeColor: "#8A8A8A",
    red: "#FF5E5E",
    dailyColor: "#4789C7",
  },
  backgroundColors: {
    mainColor: "#0085FF",
    pageBC: "#E8F4FF",
    borderDark: "#032D99",
    borderColor: "#A6D4FF",
    btnColor: "#A6D4FF",
    borderBottom: "#D7D7D7",
    cardHeaderColor: "#C9E8FF",
    cardbackgroundColor: "#FFFFFF",
  },
  card: {
    btnColor: "#96D3FF",
  },
  // mobile: `375px`,
  mobile: `430px`,
  // tablet: `768px`,
  tablet: `700px`,
};

export default theme;
